<template>
  <div>
    <!-- 面包屑导航 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>合作课程三级内容</el-breadcrumb-item>
    </el-breadcrumb>
    <!-- 搜索筛选 -->
    <el-form :inline="true" class="user-search">

      <el-form-item label="一级">
        <el-select size="small" v-model="type1" @change="selectOption1()" placeholder="请选择">
          <el-option v-for="type in typeArr1" :label="type.title" :value="type.id" :key="type.id"></el-option>
        </el-select>
      </el-form-item>

      <el-form-item label="二级">
        <el-select size="small" v-model="type2" @change="selectOption2()" placeholder="请选择">
          <el-option v-for="type in typeArr2" :label="type.title" :value="type.id" :key="type.id"></el-option>
        </el-select>
      </el-form-item>

      <el-form-item label="三级">
        <el-select size="small" v-model="type3" @change="selectOption3()" placeholder="请选择">
          <el-option v-for="type in typeArr3" :label="type.title" :value="type.id" :key="type.id"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="四级">
        <el-select size="small" v-model="type4" @change="selectOption4()" placeholder="请选择">
          <el-option v-for="type in typeArr4" :label="type.title" :value="type.id" :key="type.id"></el-option>
        </el-select>
      </el-form-item>




      <el-form-item>
        <el-button size="small" type="primary" icon="el-icon-search"
          @click="getCourseClassifyList(type4)">查询</el-button>
      </el-form-item>

      <el-form-item label="">

        <el-button size="small" type="primary" icon="el-icon-plus" @click="handleEdit()">添加</el-button>
      </el-form-item>
    </el-form>
    <!--列表-->
    <el-table :key="classifyTableRenderKey" ref="classifyTable" size="small" :data="listData" highlight-current-row v-loading="loading" border element-loading-text="拼命加载中"
      style="width: 100%;">
      <el-table-column align="center" type="selection" width="60">
      </el-table-column>
      <el-table-column align="center" label="拖动" width="70">
        <template slot-scope="scope">
          <i class="el-icon-rank drag-handle" style="cursor: move;" @click.stop></i>
        </template>
      </el-table-column>

      <el-table-column sortable prop="title" label="标题" width="200">
      </el-table-column>

      <el-table-column sortable prop="introduce" label="介绍" width="200">
      </el-table-column>


      <el-table-column sortable prop="titleOne" label="是否可以下载" width="200">
      </el-table-column>

      <el-table-column sortable prop="sort" label="排序" width="100">
      </el-table-column>


      <el-table-column prop="name" label="封面图" width="120">

        <template slot-scope="scope">
          <img style="width: 90px;height: 90px;" :src="scope.row.coverPlan">
        </template>

      </el-table-column>



      <el-table-column sortable prop="createTime" label="创建时间" width="150">
        <template slot-scope="scope">
          <div>{{ transformDate(scope.row.createTime) }}</div>
        </template>
      </el-table-column>


      <el-table-column align="center" label="操作" min-width="300">
        <template slot-scope="scope">


          <el-button size="mini" @click="handleEditIsData(scope.$index, scope.row)">资料管理</el-button>
          <el-button size="mini" @click="handleEdit(scope.$index, scope.row)">编辑</el-button>
          <el-button size="mini" type="warning" @click="openMoveParent(scope.row, type4)">修改上级</el-button>
          <el-button size="mini" type="danger" @click="deleteCourseClassify(scope.$index, scope.row)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>
    <!-- 分页组件 -->
    <!-- 编辑界面 -->
    <el-dialog :title="title" :visible.sync="editFormVisible" width="30%" @click="closeDialog">
      <el-form label-width="120px" ref="editForm">
        <el-form-item label="标题" prop="deptName">
          <el-input size="small" v-model="formData.title" auto-complete="off" placeholder="请输入"></el-input>
        </el-form-item>
        <el-form-item label="介绍" prop="deptName">
          <el-input size="small" v-model="formData.introduce" auto-complete="off" placeholder="请输入"></el-input>
        </el-form-item>
        <el-form-item label="排序" prop="deptName">
          <el-input size="small" v-model="formData.sort" auto-complete="off" placeholder="请输入"></el-input>
        </el-form-item>
        <el-form-item label="是否可以下载" prop="deptName">
          <el-input size="small" v-model="formData.titleOne" auto-complete="off" placeholder="输入'可以下载' 就可以下载"></el-input>
        </el-form-item>

        <el-form-item label="封面图" style="">

          <div class="upload-demo">
            <el-upload action="" :http-request="mainImgUpload" :show-file-list="false" list-type="picture-card">
              <i class="el-icon-plus"></i>
            </el-upload>
            <img v-if="formData.coverPlan" :src="formData.coverPlan" class="avatar">

          </div>

        </el-form-item>




      </el-form>
      <div slot="footer" class="dialog-footer">
        <!-- <el-button size="small" @click="closeDialog">取消</el-button> -->
        <el-button size="small" type="primary" :loading="loading" class="title" @click="addCourseClassify()"
          v-if="title == '添加'">添加</el-button>
        <el-button size="small" type="primary" :loading="loading" class="title" @click="upCourseClassify()"
          v-if="title == '修改'">修改</el-button>
      </div>
    </el-dialog>


    <el-dialog title="修改上级分类" :visible.sync="moveParentDialogVisible" width="460px" :close-on-click-modal="false">
      <el-form label-width="90px">
        <el-form-item label="上级分类">
          <el-cascader v-model="moveParentPath" :options="moveParentOptions" :props="moveParentProps" :disabled="moveParentSaving" filterable clearable placeholder="请选择上级分类" style="width: 100%;"></el-cascader>
        </el-form-item>
        <div style="color: #909399; line-height: 1.6;">当前分类：{{ moveParentRow && moveParentRow.title }}</div>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="moveParentDialogVisible = false">取消</el-button>
        <el-button size="small" type="primary" :loading="moveParentSaving" @click="confirmMoveParent">确定修改</el-button>
      </div>
    </el-dialog>










    <el-dialog title="资料管理" :visible.sync="isData" width="80%" :close-on-click-modal="false" @click='closeDialog("edit")'>
      <el-table :key="courseDataTableRenderKey" ref="courseDataTable" size="small" :data="courseDataList" highlight-current-row v-loading="loading" title="" border
        element-loading-text="拼命加载中" style="width: 100%;">

        <el-table-column prop="id" label="id" width="60"></el-table-column>
        <el-table-column align="center" label="拖动" width="70">
          <template slot-scope="scope">
            <i class="el-icon-rank drag-handle" style="cursor: move;" @click.stop></i>
          </template>
        </el-table-column>
        <el-table-column prop="name" label="资料名称" width="200"></el-table-column>
        <el-table-column prop="sort" label="排序" width="100"></el-table-column>

        <el-table-column prop="name" label="封面图" width="120">

          <template slot-scope="scope">
            <img style="width: 90px;height: 90px;" :src="scope.row.coverPlan">
          </template>

        </el-table-column>


        <el-table-column prop="createTime" label="创建时间" width="200">
          <template slot-scope="scope">
            <div>{{ transformDate(scope.row.createTime) }}</div>
          </template>
        </el-table-column>
        <!-- <el-table-column sortable prop="editUser" label="修改人" width="300">
       </el-table-column> -->
        <el-table-column align="center" label="操作" min-width="300">
          <template slot-scope="scope">
            <el-button size="mini" @click="handleEditCourseData(scope.$index, scope.row)">编辑</el-button>
            <el-button size="mini" type="warning" @click="openMoveCourseData(scope.row)">移动分类</el-button>
            <el-button size="mini" type="danger" @click='deleteCourseData(scope.row)'>删除</el-button>
            <el-button size="mini" type="success" @click="getCourseFileDataList(scope.row.id,scope.row.courseClassifyId)">文件列表</el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-form :inline="true" :model="formInline">


        <el-form-item>




          <!-- <el-upload class="upload-demo" :action="accessoryAction" :on-preview="handlePreview" :on-remove="handleRemove"
            :before-remove="beforeRemove" multiple :limit="3" :on-exceed="handleExceed" :on-success="accessoryfileSuccess"
            :on-change="accessoryfileChange" :file-list="fileList">

            <el-button size="small" type="primary" icon="el-icon-upload2">上传</el-button>


          </el-upload> -->


          <el-button size="small" type="primary" class="title" @click="handleEditCourseData()">添加</el-button>

        </el-form-item>




      </el-form>
    </el-dialog>

    <el-dialog title="移动资料分类" :visible.sync="moveDialogVisible" width="460px" :close-on-click-modal="false">
      <el-form label-width="90px">
        <el-form-item label="目标分类">
          <el-cascader
            v-model="moveTargetPath"
            :options="moveCategoryOptions"
            :props="moveCategoryProps"
            :disabled="moveSaving"
            filterable
            clearable
            placeholder="请选择目标分类"
            style="width: 100%;"
          ></el-cascader>
        </el-form-item>
        <div style="color: #909399; line-height: 1.6;">移动资料时，下面的文件会一起移动到目标分类。</div>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="moveDialogVisible = false">取消</el-button>
        <el-button size="small" type="primary" :loading="moveSaving" @click="confirmMoveCourseData">确定移动</el-button>
      </div>
    </el-dialog>



    <el-dialog ref="fileDataDialog" title="文件管理" :visible.sync="editFormVisibleFile" width="80%" :close-on-click-modal="false">
      <el-table :key="fileDataTableRenderKey" ref="fileDataTable" row-key="id" size="small" :data="fileDataList" highlight-current-row v-loading="loading" title="" border
        element-loading-text="拼命加载中" style="width: 100%;">

        <el-table-column prop="id" label="id" width="60"></el-table-column>
        <el-table-column align="center" label="拖动" width="70">
          <template slot-scope="scope">
            <i class="el-icon-rank drag-handle" style="cursor: move;" @click.stop></i>
          </template>
        </el-table-column>
        <el-table-column prop="name" label="文件名称" width="200"></el-table-column>
        <el-table-column prop="sort" label="排序" width="100"></el-table-column>

        <el-table-column prop="name" label="缩略图" width="120">

          <template slot-scope="scope">
            <img style="width: 90px;height: 90px;" :src="scope.row.dataUrl">
          </template>

          </el-table-column>


        <el-table-column prop="createTime" label="创建时间" width="200">
          <template slot-scope="scope">
            <div>{{ transformDate(scope.row.createTime) }}</div>
          </template>
        </el-table-column>
        <!-- <el-table-column sortable prop="editUser" label="修改人" width="300">
       </el-table-column> -->
        <el-table-column align="center" label="操作" min-width="300">
          <template slot-scope="scope">

            <el-button size="mini" @click="handleEditFileCourseData(scope.$index, scope.row)">编辑</el-button>
            <el-button size="mini" type="danger" @click='deleteFileCourseData(scope.row)'>删除</el-button>
            <el-button size="mini" type="success" @click="openFile(scope.row.dataUrl)">下载</el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-form :inline="true" :model="formInline">


        <el-form-item>

          <el-upload class="upload-demo" :http-request="testTx" :show-file-list="false" :multiple="true" list-type="picture-card" :on-progress="handleProgress">

            <el-button size="small" type="primary" icon="el-icon-upload2">{{ uploadText }}</el-button>


          </el-upload>

          <!-- <el-button size="small" type="primary" class="title" @click="editFormVisibleCourseData = true">添加</el-button> -->

        </el-form-item>

      </el-form>
    </el-dialog>





    <!-- 编辑界面 -->
    <el-dialog :title="courseDataTitle" :visible.sync="editFormVisibleCourseData" width="30%" @click="closeDialog">
      <el-form label-width="120px" ref="editForm">
        <el-form-item label="名称" prop="deptName">
          <el-input size="small" v-model="courseData.name" auto-complete="off" placeholder="请输入"></el-input>
        </el-form-item>


        <el-form-item label="排序" prop="deptName">
          <el-input size="small" v-model="courseData.sort" auto-complete="off" placeholder="请输入"></el-input>
        </el-form-item>



        <el-form-item label="封面图" style="">

          <div class="upload-demo">
            <el-upload action="" :http-request="mainImgUpload1" :show-file-list="false" list-type="picture-card">
              <i class="el-icon-plus"></i>
            </el-upload>
            <img v-if="courseData.coverPlan" :src="courseData.coverPlan" class="avatar">

          </div>

        </el-form-item>

        <!-- <el-form-item label="上传文件" style="">

          <el-upload class="upload-demo" :http-request="testTx" :show-file-list="false" list-type="picture-card">

            <el-button size="small" type="primary" icon="el-icon-upload2">上传</el-button>


          </el-upload>

        </el-form-item> -->


        <!-- <el-form-item label="上传状态" style="" >
            <a :href="courseData.dataUrl">查看{{ courseData.dataUrl }}</a>
        </el-form-item> -->




      </el-form>
      <div slot="footer" class="dialog-footer">
        <!-- <el-button size="small" @click="closeDialog">取消</el-button> -->
        <!-- <el-button size="small" type="primary" :loading="loading" class="title" @click="addCourseData()">添加</el-button> -->

        <el-button size="small" type="primary" :loading="loading" class="title" @click="addCourseData()"
          v-if="courseDataTitle == '添加'">添加</el-button>
        <el-button size="small" type="primary" :loading="loading" class="title" @click="upCourseData()"
          v-if="courseDataTitle == '修改'">修改</el-button>
      </div>
    </el-dialog>







    <!-- 编辑界面 -->
    <el-dialog :title="title" :visible.sync="editFormVisibleFileCourseData" width="30%" @click="closeDialog">
      <el-form label-width="120px" ref="editForm">
        <el-form-item label="名称" prop="deptName">
          <el-input size="small" v-model="fileCourseData.name" auto-complete="off" placeholder="请输入"></el-input>
        </el-form-item>
        <el-form-item label="排序" prop="deptName">
          <el-input size="small" v-model="fileCourseData.sort" auto-complete="off" placeholder="请输入"></el-input>
        </el-form-item>



        <el-form-item label="是否可以下载" prop="deptName">
          <el-input size="small" v-model="fileCourseData.titleOne" auto-complete="off" placeholder="输入'可以下载' 就可以下载"></el-input>
        </el-form-item>

        <!-- <el-form-item label="上传文件" style="">

          <el-upload class="upload-demo" :http-request="testTx" :show-file-list="false" list-type="picture-card">

            <el-button size="small" type="primary" icon="el-icon-upload2">上传</el-button>


          </el-upload>

        </el-form-item> -->


        <!-- <el-form-item label="上传状态" style="" >
            <a :href="courseData.dataUrl">查看{{ courseData.dataUrl }}</a>
        </el-form-item> -->




      </el-form>
      <div slot="footer" class="dialog-footer">
        <!-- <el-button size="small" @click="closeDialog">取消</el-button> -->
        <!-- <el-button size="small" type="primary" :loading="loading" class="title" @click="addCourseData()">添加</el-button> -->

        <el-button size="small" type="primary" :loading="loading" class="title" @click="upCourseFileData()"
          v-if="title == '修改'">修改</el-button>
      </div>
    </el-dialog>



  </div>
</template>

<script>
import {




  addCourseClassify,
  upCourseClassify,
  upCourseClassifySort,
  deleteCourseClassify,
  getCourseClassifyList,


  addCourseData,
  deleteCourseData,
  getCourseClassifyDataList,
  moveCourseData,

  getSignatureVue,
  upCourseData,
  upCourseDataSort


} from "../../api/userMG";
import Pagination from "../../components/Pagination";
import client from "@/utils/ossClient.js";
import { createTableDragSort, updateSortSequentially } from "@/utils/tableDragSort";
import uploadProgress from "@/utils/uploadProgress";
import courseClassifyMove from "../../mixins/courseClassifyMove";
import courseFileListScroll from "../../mixins/courseFileListScroll";

import TcVod from 'vod-js-sdk-v6'


export default {
  mixins: [courseClassifyMove, courseFileListScroll],
  data() {
    return {

      moveParentClassifyType: 0,
      moveParentDepth: 4,

      uploadText:"上传",
      isData: false,
      classifyTableRenderKey: 0,
      courseDataTableRenderKey: 0,
      fileDataTableRenderKey: 0,






      type1: 0,
      typeArr1: [],


      type2: 0,
      typeArr2: [],
      type3: 0,
      typeArr3: [],


      type4: 0,
      typeArr4: [],

      nshow: true, //switch开启
      fshow: false, //switch关闭
      loading: false, //是显示加载
      editFormVisible: false, //控制编辑页面显示与隐藏
      title: "添加",
      listDragSortInstance: null,
      courseDataDragSortInstance: null,
      fileDataDragSortInstance: null,

      listData: [], //
      // 分页参数
      pageparm: {
        currentPage: 1,
        pageSize: 20,
        total: 10,
      },


      formData: {
        coverPlan: "",//封面图
        title: "",//标题     
        introduce: "",//介绍   
        difficultyLevel: "",//难度等级   
        superiorId: 0,//上级ID   
        level: 0,//分类等级     
        type: 2,// 0课程分类，1直播分类，2vip分类  
        titleOne: "",//二级标题     
        introduceOne: "",//二级介绍  
        sort:0

      },

      courseDataList: [],//课程资料
      editFormVisibleCourseData: false, //控制编辑页面显示与隐藏
      courseData: {
        name: "",//名称
        coverPlan: "",//封面图     
        courseClassifyId: "",//课程分类资料ID
        courseId: 0,//资料ID
        type: "",// 资料类型      
        superiorId:0,
        sort: 0,
      },

      moveDialogVisible: false,
      moveSaving: false,
      moveCategoryOptions: [],
      moveCategoryProps: {
        value: "id",
        label: "title",
        children: "children",
        checkStrictly: true,
        lazy: true,
        lazyLoad: (node, resolve) => this.loadMoveCategoryChildren(node, resolve),
      },
      moveTargetPath: [],
      moveCourseDataRow: null,


      fileDataList: [],//课程资料

      editFormVisibleFile:false,


      courseDataTitle: "添加",





      editFormVisibleFileCourseData:false,//文件编辑

      fileCourseData: {

        
        dataUrl: "",
        fileId:  "",
        name: "",//名称
        coverPlan: "",//封面图     
        courseClassifyId: "",//课程分类资料ID
        courseId: 0,//资料ID
        type: "",// 资料类型      
        superiorId:0,
        sort:"",
        titleOne:""


      },


    };
  },
  // 注册组件
  components: {
    Pagination,
  },
  /**
   * 数据发生改变
   */

  /**
   * 创建完毕
   */
  created() {


    this.getSuperiorCourseClassifyList(0, 0)

  },
  beforeDestroy() {
    if (this.listDragSortInstance) {
      this.listDragSortInstance.destroy();
    }
    if (this.courseDataDragSortInstance) {
      this.courseDataDragSortInstance.destroy();
    }
    if (this.fileDataDragSortInstance) {
      this.fileDataDragSortInstance.destroy();
    }
  },

  /**
   * 里面的方法只有被调用才会执行
   */
  methods: {
    getOriginalFileName(file) {
      return (file && file.name) || "";
    },
    initListDragSort() {
      if (!this.listDragSortInstance) {
        this.listDragSortInstance = createTableDragSort(this, {
          tableRef: "classifyTable",
          listKey: "listData",
          onSorted: this.handleListDragSort,
        });
      }
      this.listDragSortInstance.init();
    },
    initCourseDataDragSort() {
      if (!this.courseDataDragSortInstance) {
        this.courseDataDragSortInstance = createTableDragSort(this, {
          tableRef: "courseDataTable",
          listKey: "courseDataList",
          onSorted: this.handleCourseDataDragSort,
        });
      }
      this.courseDataDragSortInstance.init();
    },
    initFileDataDragSort() {
      if (!this.fileDataDragSortInstance) {
        this.fileDataDragSortInstance = createTableDragSort(this, {
          tableRef: "fileDataTable",
          listKey: "fileDataList",
          onSorted: this.handleFileDataDragSort,
        });
      }
      this.fileDataDragSortInstance.init();
    },
    async handleListDragSort({ list, oldList }) {
      this.loading = true;
      try {
        const result = await updateSortSequentially(list, (item) =>
          upCourseClassifySort({
            id: item.id,
            sort: item.sort,
          })
        , oldList);
        if (!result || result.code != 200) {
          this.$message.error((result && result.msg) || "排序保存失败");
        } else {
          this.$message({
            type: "success",
            message: "排序已更新",
          });
        }
        this.getCourseClassifyList(this.type4);
      } catch (e) {
        this.loading = false;
        this.$message.error("排序保存失败，请稍后再试！");
        this.getCourseClassifyList(this.type4);
      }
    },
    async handleCourseDataDragSort({ list, oldList }) {
      this.loading = true;
      try {
        const result = await updateSortSequentially(list, (item) =>
          upCourseDataSort({
            id: item.id,
            sort: item.sort,
          })
        , oldList);
        if (!result || result.code != 200) {
          this.$message.error((result && result.msg) || "资料排序保存失败");
        } else {
          this.$message({
            type: "success",
            message: "资料排序已更新",
          });
        }
        this.getCourseClassifyDataList(this.courseData.courseClassifyId);
      } catch (e) {
        this.loading = false;
        this.$message.error("资料排序保存失败，请稍后再试！");
        this.getCourseClassifyDataList(this.courseData.courseClassifyId);
      }
    },
    async handleFileDataDragSort({ list, oldList }) {
      this.loading = true;
      try {
        const result = await updateSortSequentially(list, (item) =>
          upCourseDataSort({
            id: item.id,
            sort: item.sort,
          })
        , oldList);
        if (!result || result.code != 200) {
          this.$message.error((result && result.msg) || "文件排序保存失败");
        } else {
          this.$message({
            type: "success",
            message: "文件排序已更新",
          });
        }
        this.getCourseFileDataList(this.courseData.superiorId, this.courseData.courseClassifyId, true);
      } catch (e) {
        this.loading = false;
        this.$message.error("文件排序保存失败，请稍后再试！");
        this.getCourseFileDataList(this.courseData.superiorId, this.courseData.courseClassifyId, true);
      }
    },

    handleProgress(event, file, fileList) {
      // event 参数包含了上传进度的信息
      console.log(`当前进度：${event.percent}`);
    },

    openFile(fileName) {
      window.open(fileName);
    },


    testTx(file) {

 
      var self = this;
      // 通过 import 引入的话，new TcVod(opts) 即可
      // new TcVod.default(opts) 是 script 引入 的用法
      const tcVod = new TcVod({
        getSignature: this.getSignature

      })



      var fileName = this.getOriginalFileName(file.file);
      var fileType = file.file.type;


      
      var type = 1;

      if (fileType.indexOf("video")!=-1) {
        //视频
        type = 0

      }

      if (fileType.indexOf("application")!=-1) {
        //ppt
        type = 1


      }

      if ( fileType.indexOf("image")!=-1) {
        //照片
        type = 2

      }

      if (type != 0) {
        console.log("1111111111111111")

        this.uploadText = "上传中...";

        //判断扩展名
        const tmpcnt = file.file.name.lastIndexOf(".");
        const exname = file.file.name.substring(tmpcnt + 1);
        // const names = ["jpg", "jpeg", "webp", "png", "bmp"];
        // if (names.indexOf(exname) < 0) {
        //   this.$message.error("不支持的格式!");
        //   return;
        // }
        const uploadFileName = file.file.uid + "." + exname;
        client
          .put(uploadFileName, file.file,{
            progress: function (p) {
              // p是一个0到1的进度百分比
              console.log(`Progress: ${((p * 100) | 0)}%`);
            }
          })
          .then((res) => {


            console.log("1111111111",res)

            this.uploadText = "上传成功";
            var courseData = {
              dataUrl:  res.url,
              fileId:  res.name,
              name: fileName,//名称
              coverPlan: "",//封面图     
              courseClassifyId: self.courseData.courseClassifyId,//课程分类资料ID
              courseId:  self.courseData.courseId,//资料ID
              type: type,// 资料类型      
              superiorId:self.courseData.superiorId,

            }






            self.addCourseFileData(courseData);

            if (res.url) {
              
            } else {
              this.$message.error("文件上传失败");
            }
          })
          .catch((err) => {
            this.uploadText = "上传失败";
            console.log("2222222222",err)
          });


        return;
      }










      const uploader = tcVod.upload({
        mediaFile: file.file, // 媒体文件（视频或音频或图片），类型为 File
      })
      const progressToken = uploadProgress.start(fileName)
      uploader.on('media_progress', function (info) {
        console.log("进度") // 进度

        console.log(info) // 进度
        uploadProgress.update((info.percent || 0) * 100, progressToken)
      })


      // 回调结果说明
      // type doneResult = {
      //   fileId: string,
      //   video: {
      //     url: string
      //   },
      //   cover: {
      //     url: string
      //   }
      // }
      uploader.done().then(function (doneResult) {
        // deal with doneResult
        console.log("doneResult") // 进度
        console.log(doneResult) // 进度


        // self.courseData.dataUrl = doneResult.video.url;
        // self.courseData.fileId = doneResult.fileId;

        // var courseData = JSON.parse(JSON.stringify(self.courseData ) )
        // courseData.name = fileName
            var courseData = {
              dataUrl:   doneResult.video.url,
              fileId:  doneResult.fileId,
              name: fileName,//名称
              coverPlan: "",//封面图     
              courseClassifyId: self.courseData.courseClassifyId,//课程分类资料ID
              courseId:  self.courseData.courseId,//资料ID
              type: type,// 资料类型      
              superiorId:self.courseData.superiorId,

            }





        self.addCourseFileData(courseData);
        uploadProgress.finish(true, progressToken)






      }).catch(function (err) {
        // deal with error
        console.log("err") // 进度
        console.log(err) // 进度
        uploadProgress.finish(false, progressToken)
      })




    },


    getSignature() {


      // return "hLYFcsZG4esjzjzqPVfHDsSK6s9zZWNyZXRJZD1BS0lEOUE1b0lhZ1lWRnZPZWdUMk5WUjljcnRnR2h2dWtMaXEmY3VycmVudFRpbWVTdGFtcD0xNzAyMjMwOTYzJmV4cGlyZVRpbWU9MTcyMjIzMDk2MyZyYW5kb209MTcwMjIzMDk2Mw==";







      return getSignatureVue().then((res) => {

        console.log("调用签名", res.data.signature) // 进度
        return res.data.signature;
      });


      //       return axios.post("http://smxz.natapp1.cc/app-yijiu-backstage/getSignature").then(function (response) {

      // console.log("调用签名",response) // 进度

      // return response.data.signature;
      // })







    },

    selectOption1() {

      this.getSuperiorCourseClassifyList(this.type1, 1)

    },
    selectOption2() {

      this.getSuperiorCourseClassifyList(this.type2, 2)

    },

    selectOption3() {

      this.getSuperiorCourseClassifyList(this.type3, 3)

    },



    selectOption4() {

      this.getCourseClassifyList(this.type4)

    },


    // 按等级获取数据
    getSuperiorCourseClassifyList(superiorId, level) {
      this.loading = true;

      getCourseClassifyList({ type: 2, superiorId: superiorId ,classifyType:0}).then((res) => {
        this.loading = false;
        if (res.code == 200) {
          if (level == 0) {

            this.typeArr2 = [];
            this.type2 = "";
            this.typeArr3 = [];
            this.type3 = "";
            this.typeArr4 = [];
            this.type4 = "";
            this.listData = []
            //选择的第一级
            this.typeArr1 = res.data.list;
            this.type1 = this.typeArr1[0].id;







            this.getSuperiorCourseClassifyList(this.type1, 1)
          }
          if (level == 1) {

            this.typeArr3 = [];
            this.type3 = "";
            this.typeArr4 = [];
            this.type4 = "";
            this.listData = []


            //选择的第二级
            this.typeArr2 = res.data.list;
            this.type2 = this.typeArr2[0].id;




            this.getSuperiorCourseClassifyList(this.type2, 2)
          }
          if (level == 2) {
            this.typeArr4 = [];
            this.type4 = "";
            //选择的第三级
            this.typeArr3 = res.data.list;
            this.type3 = this.typeArr3[0].id;


            this.getSuperiorCourseClassifyList(this.type3, 3)
          }
          if (level == 3) {

            this.listData = []
            //选择的第四级
            this.typeArr4 = res.data.list;
            this.type4 = this.typeArr4[0].id;


            this.getCourseClassifyList(this.type4)
          }



        } else {




        }

      });
    },





    // 删除
    deleteCourseClassify(index, row) {
      this.$confirm("确定要删除吗?", "信息", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          deleteCourseClassify({ id: row.id })
            .then((res) => {
              if (res.code == 200) {
                this.$message({
                  type: "success",
                  message: "已删除！",
                });
                this.getCourseClassifyList(this.type4);
              } else {
                this.$message({
                  type: "info",
                  message: res.msg,
                });
              }
            })
            .catch((err) => {
              this.loading = false;
              this.$message.error("删除失败，请稍后再试！");
            });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除",
          });
        });
    },

    //修改
    upCourseClassify() {

      this.loading = true;
      var formData = JSON.parse(JSON.stringify(this.formData));


      upCourseClassify(formData).then((res) => {
        this.loading = false;
        if (res.code == 200) {
          this.editFormVisible = false
          this.$message({
            type: "success",
            message: res.msg,
          });
          this.getCourseClassifyList(this.type4);
        } else {
          this.$message.error(res.msg);
        }
      });
    },

    //添加分类
    addCourseClassify() {

      this.loading = true;

      var formData = JSON.parse(JSON.stringify(this.formData))




      addCourseClassify(this.formData).then((res) => {
        this.loading = false;
        if (res.code == 200) {
          this.editFormVisible = false
          this.$message({
            type: "success",
            message: res.msg,
          });
          this.getCourseClassifyList(this.type4);
        } else {
          this.$message.error(res.msg);
        }
      });
    },


    //添加课程资料
    addCourseData() {


      var formData = JSON.parse(JSON.stringify(this.courseData))




      addCourseData(formData).then((res) => {
        this.loading = false;
        if (res.code == 200) {
          this.editFormVisibleCourseData = false
          this.$message({
            type: "success",
            message: res.msg,
          });
          this.courseData.name = "";
          this.getCourseClassifyDataList(this.courseData.courseClassifyId)
        } else {
          this.$message.error(res.msg);
        }
      });
    },
    //修改课程资料
    upCourseData() {


      var formData = JSON.parse(JSON.stringify(this.courseData))

      upCourseData(formData).then((res) => {
        this.loading = false;
        if (res.code == 200) {
          this.editFormVisibleCourseData = false
          this.$message({
            type: "success",
            message: res.msg,
          });
          this.courseData.name = "";
          this.getCourseClassifyDataList(this.courseData.courseClassifyId)
        } else {
          this.$message.error(res.msg);
        }
      });
    },



    


    //自定义上传方法..
    mainImgUpload(file) {

      //判断扩展名
      const tmpcnt = file.file.name.lastIndexOf(".");
      const exname = file.file.name.substring(tmpcnt + 1);
      // const names = ["jpg", "jpeg", "webp", "png", "bmp"];
      // if (names.indexOf(exname) < 0) {
      //   this.$message.error("不支持的格式!");
      //   return;
      // }
      const fileName = file.file.uid + "." + exname;
      client
        .put(fileName, file.file)
        .then((res) => {
          if (res.url) {
            this.formData.coverPlan = res.url;
          } else {
            this.$message.error("文件上传失败");
          }
        })
        .catch((err) => { });
    },

    //自定义上传方法..
    mainImgUpload1(file) {
      const originalFileName = this.getOriginalFileName(file.file);

      //判断扩展名
      const tmpcnt = file.file.name.lastIndexOf(".");
      const exname = file.file.name.substring(tmpcnt + 1);
      // const names = ["jpg", "jpeg", "webp", "png", "bmp"];
      // if (names.indexOf(exname) < 0) {
      //   this.$message.error("不支持的格式!");
      //   return;
      // }
      const fileName = file.file.uid + "." + exname;
      client
        .put(fileName, file.file)
        .then((res) => {
          if (res.url) {
            this.courseData.coverPlan = res.url;
            if (!this.courseData.name) {
              this.courseData.name = originalFileName;
            }
          } else {
            this.$message.error("文件上传失败");
          }
        })
        .catch((err) => { });
    },


    // 获取
    getCourseClassifyList(superiorId) {
      this.loading = true;

      getCourseClassifyList({ type: 2, superiorId: superiorId,classifyType:0 }).then((res) => {
        this.loading = false;
        if (res.code == 200) {
          this.listData = res.data.list;
          this.classifyTableRenderKey += 1;
          this.$nextTick(() => {
            this.initListDragSort();
          });
          return;
        }
        this.$message({
          type: "info",
          message: res.msg,
        });
      });
    },









    //显示编辑界面
    handleEditIsData: function (index, row) {
      this.isData = true;
      this.courseData.courseClassifyId = row.id;
      this.getCourseClassifyDataList(row.id)
    },
    // 获取资料数据列表
    getCourseClassifyDataList(courseClassifyId) {
      this.loading = true;

      getCourseClassifyDataList({ superiorId: 0, courseClassifyId: courseClassifyId }).then((res) => {
        this.loading = false;
        if (res.code == 200) {
          this.courseDataList = res.data.list;
          this.courseDataTableRenderKey += 1;
          this.$nextTick(() => {
            this.initCourseDataDragSort();
          });
          return;
        }
        this.$message({
          type: "info",
          message: res.msg,
        });
      });
    },

    async openMoveCourseData(row) {
      if (!row || !row.id) return;
      this.moveCourseDataRow = row;
      this.moveTargetPath = [];
      this.moveCategoryOptions = [];
      this.moveDialogVisible = true;
    },

    async loadMoveCategoryChildren(node, resolve) {
      const superiorId = node && node.level > 0 ? node.value : 0;
      try {
        const res = await getCourseClassifyList({ type: 2, superiorId: superiorId, classifyType: 0 });
        if (!res || res.code != 200) {
          throw new Error("分类加载失败");
        }
        const list = (res.data && res.data.list) || [];
        resolve(list.map((item) => ({
          id: item.id,
          title: item.title,
          leaf: false,
        })));
      } catch (e) {
        resolve([]);
        this.$message.error("分类加载失败，请稍后再试！");
      }
    },

    async confirmMoveCourseData() {
      const path = Array.isArray(this.moveTargetPath) ? this.moveTargetPath : [];
      const targetId = path.length ? path[path.length - 1] : null;
      const row = this.moveCourseDataRow;
      if (!row || !targetId) {
        this.$message.warning("请选择目标分类！");
        return;
      }
      if (String(targetId) === String(row.courseClassifyId)) {
        this.$message.info("目标分类与当前分类相同");
        return;
      }

      this.moveSaving = true;
      try {
        const res = await moveCourseData({ id: row.id, courseClassifyId: targetId });
        if (!res || res.code != 200) {
          this.$message.error((res && res.msg) || "移动失败！");
          return;
        }
        this.$message.success(res.msg || "移动成功！");
        this.moveDialogVisible = false;
        this.getCourseClassifyDataList(this.courseData.courseClassifyId);
      } catch (e) {
        this.$message.error("移动失败，请稍后再试！");
      } finally {
        this.moveSaving = false;
      }
    },




    // 获取资料数据列表
    getCourseFileDataList(superiorId,courseClassifyId, resetTable = false) {
      const scrollPosition = this.captureFileListScroll(superiorId, courseClassifyId);
      this.loading = true;

      getCourseClassifyDataList({ superiorId: superiorId, courseClassifyId: courseClassifyId }).then((res) => {
        this.loading = false;
        if (res.code == 200) {
          this.fileDataList = res.data.list;

          this.editFormVisibleFile = true;

          this.courseData.superiorId = superiorId;
          this.courseData.courseClassifyId = courseClassifyId;
          // 拖动排序后需要重建表格以同步 DOM；普通编辑刷新保留现有行。
          if (resetTable) {
            this.fileDataTableRenderKey += 1;
          }
          this.$nextTick(() => {
            this.initFileDataDragSort();
            this.restoreFileListScroll(scrollPosition);
          });
          return;
        }
        this.$message({
          type: "info",
          message: res.msg,
        });
      });
    },

    


    //添加文件资料
    addCourseFileData(courseData) {
      var formData = JSON.parse(JSON.stringify(courseData))

      formData.sort = 0;
      addCourseData(formData).then((res) => {
        this.loading = false;
        if (res.code == 200) {
          this.editFormVisibleCourseData = false
          this.$message({
            type: "success",
            message: res.msg,
          });
          this.courseData.name = "";
          this.getCourseFileDataList(this.courseData.superiorId,this.courseData.courseClassifyId)
        } else {
          this.$message.error(res.msg);
        }
      });
    },



    //修改文件资料
    upCourseFileData() {


      var formData = JSON.parse(JSON.stringify(this.fileCourseData))

      upCourseData(formData).then((res) => {
        this.loading = false;
        if (res.code == 200) {
          this.editFormVisibleFileCourseData = false
          this.$message({
            type: "success",
            message: res.msg,
          });
          this.courseData.name = "";
          this.getCourseFileDataList(this.courseData.superiorId,this.courseData.courseClassifyId)
        } else {
          this.$message.error(res.msg);
        }
      });
    },



    

    // 删除
    deleteFileCourseData(row) {
      this.$confirm("确定要删除吗?", "信息", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          deleteCourseData({ id: row.id })
            .then((res) => {
              if (res.code == 200) {
                this.$message({
                  type: "success",
                  message: "已删除！",
                });
                this.getCourseFileDataList(this.courseData.superiorId,this.courseData.courseClassifyId)
              } else {
                this.$message({
                  type: "info",
                  message: res.msg,
                });
              }
            })
            .catch((err) => {
              this.loading = false;
              this.$message.error("删除失败，请稍后再试！");
            });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除",
          });
        });
    },
    





    // 删除
    deleteCourseData( row) {
      this.$confirm("确定要删除吗?", "信息", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          deleteCourseData({ id: row.id })
            .then((res) => {
              if (res.code == 200) {
                this.$message({
                  type: "success",
                  message: "已删除！",
                });
                this.getCourseClassifyDataList(this.courseData.courseClassifyId)
              } else {
                this.$message({
                  type: "info",
                  message: res.msg,
                });
              }
            })
            .catch((err) => {
              this.loading = false;
              this.$message.error("删除失败，请稍后再试！");
            });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除",
          });
        });
    },

    // 分页插件事件
    callFather(parm) {
      this.getDishesList(parm.currentPage);
    },

    //显示文件编辑界面
    handleEditFileCourseData: function (index, row) {

      
      this.editFormVisibleFileCourseData = true;
      if (row != undefined && row != "undefined") {
        this.title = "修改";
        this.fileCourseData.id = row.id;
        this.fileCourseData.dataUrl = row.dataUrl;
        this.fileCourseData.fileId = row.fileId;
        this.fileCourseData.name = row.name;
        this.fileCourseData.coverPlan = row.coverPlan;
        this.fileCourseData.courseClassifyId = row.courseClassifyId;
        this.fileCourseData.courseId = row.courseId;
        this.fileCourseData.type = row.type;
        this.fileCourseData.superiorId = row.superiorId;
        this.fileCourseData.sort = row.sort;
        this.fileCourseData.titleOne = row.titleOne;


      




      } else {
        this.title = "添加";
       
        this.fileCourseData.dataUrl =  "";
        this.fileCourseData.fileId =  "";
        this.fileCourseData.name =  "";
        this.fileCourseData.coverPlan =  "";
        this.fileCourseData.courseClassifyId =  "";
        this.fileCourseData.courseId =  "";
        this.fileCourseData.type =  "";
        this.fileCourseData.superiorId =  "";
        this.fileCourseData.sort = "";
        this.fileCourseData.titleOne = "";
      }
    },
        //显示编辑界面
    handleEditCourseData: function (index, row) {
      this.editFormVisibleCourseData = true;
      if (row != undefined && row != "undefined") {
        this.courseDataTitle = "修改";
        this.courseData.id = row.id;
        this.courseData.coverPlan = row.coverPlan;
        this.courseData.name = row.name;
        this.courseData.sort = row.sort;

        




      } else {
        this.courseDataTitle = "添加";
        this.courseData.id = "";
        this.courseData.coverPlan = "";
        this.courseData.name = "";
        this.courseData.sort = 0;
      }
    },
    //显示编辑界面
    handleEdit: function (index, row) {
      this.editFormVisible = true;
      if (row != undefined && row != "undefined") {
        this.title = "修改";
        this.formData.id = row.id;
        this.formData.coverPlan = row.coverPlan;
        this.formData.introduce = row.introduce;
        this.formData.title = row.title;
        this.formData.introduceOne = row.introduceOne;
        this.formData.titleOne = row.titleOne;
        this.formData.difficultyLevel = row.difficultyLevel;
        this.formData.superiorId = row.superiorId;
        this.formData.sort = row.sort;
        this.formData.classifyType = 0;



      } else {
        this.title = "添加";
        this.formData.id = "";
        this.formData.coverPlan = "";
        this.formData.introduce = "";
        this.formData.title = "";
        this.formData.introduceOne = "";
        this.formData.titleOne = "";
        this.formData.difficultyLevel = 1;
        this.formData.superiorId = this.type4;
        this.formData.sort = "";
        this.formData.classifyType = 0;



      }
    },

    // 关闭编辑、增加弹出框
    closeDialog() {
      this.editFormVisible = false;
    },
  },
};
</script>

<style scoped>
.user-search {
  margin-top: 20px;
}

.userRole {
  width: 100%;
}

.upload-demo {
  display: flex;
  flex-direction: row;
}

.upload-demo img {
  width: 140px;
  height: 140px;
}
</style>

 
 



// WEBPACK FOOTER //
// src/views/cooperation/CourseList.vue